import { useEffect, useState } from "react";

import { loadReferences } from "@frontend/lib/references";
import type { Reference } from "@frontend/lib/references";

type Loaded = {
  taskTypeId: number;
  items: Reference[];
};

/**
 * The sub types of one task type, empty while none is picked.
 *
 * What was loaded is kept with the type it belongs to, so switching type
 * empties the list by deriving it rather than by writing state twice.
 */
export function useSubTaskTypes(taskTypeId: number | null): Reference[] {
  const [loaded, setLoaded] = useState<Loaded | null>(null);

  useEffect(() => {
    if (null === taskTypeId) {
      return;
    }

    let current = true;

    loadReferences("subTaskTypes", { taskTypeId })
      .then((items) => {
        if (current) {
          setLoaded({ taskTypeId, items });
        }
      })
      .catch(() => {
        // An empty list reads as "nothing to pick", which is what a failure
        // leaves the form with anyway.
      });

    return () => {
      current = false;
    };
  }, [taskTypeId]);

  return loaded?.taskTypeId === taskTypeId ? loaded.items : [];
}
